
import { useContext, useEffect, useState, useRef } from 'react'
import axios from 'axios'
import Modal from 'react-modal'
import { useForm } from 'react-hook-form'

import { groupBy, projectContext, loadingContext, urlValue, unfolder, closeModalVw, openModalVw } from '../../lib'
// import AsideBar from './AsideBar'
import * as XLSX from 'xlsx';
import '../../styles/settings.scss'
import { customModal } from '../../styles/customModal'
import SideBar from '../../components/SideBar'
import TitleBar from '../../components/TitleBar'
import { useNavigate } from 'react-router-dom'
import ModalVw, { ModalBody, ModalContent, ModalHeader } from '../../components/common/ModalVw'
import Report from '../Report'
import ReportItem from './ReportItem'
// import MenuHeader from './MenuHeader'
// import trash from "../img/icons/trash.png"
// import expandleft from "../img/icons/Expand_left.svg"
// import searchicon from "../img/icons/search.svg"
// import editicon from "../img/icons/edit.png"
// import watchReport from "../img/icons/see-report-icon.jpg"

export default function ListReport(props) {
    const { openReport, openCallReport, downloadPDF, listCall, search, id } = props
    const navigate = useNavigate();
    const [refresh, setRefresh] = useState(false)

    const ref = useRef(null)
    const [call_list, setCallList] = useState(listCall)
    useEffect(() => {
        setCallList(listCall)
    }, [listCall])

    const orderBy = async (column, e) => {

        if (e.target.classList.contains('rotar')) {
            //   getReports(column, 'asc');
        } else {
            //   getReports(column, 'desc');
        }
        e.target.classList.toggle("rotar")
        //setLogs(log)
    }
    return (



        Object.entries(groupBy(listCall, 'project_name')).map(([project, groupItems]) => {



            return (
                <div className="elements" ref={ref} style={{ width: '100%', backgroundColor: '#F7F7F7', display: 'flex', 
                    flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-start', width: '100%'}}>
                            <div className='flex items-center'> <div className='title-subreport' style={{textAlign: 'left', width: '100%'}}>
                                {project}
                            </div>
                            <img onClick={()=>{ }} src={'/icons/dashboard-icon.png'} alt="expand" style={{marginLeft: 9,  width: 20, height: 20, cursor: 'pointer' }}  /></div>
                        </div>
                    
                    <table className="table-reports  " style={{ width: '100%', marginLeft: 20, backgroundColor: 'white' }}>
                        <thead>
                            <tr>
                                <th> <div className='icos-th'><span>ID</span>  </div></th>
                                <th> <div className='icos-th'><span>Project</span>  </div></th>
                                <th> <div className='icos-th'><span>User</span>  </div></th>
                                <th> <div className='icos-th'><span>Date</span>  </div></th>
                                <th><div className='icos-th'><span>Duration</span>   </div></th>
                                <th><div className='icos-th'><span>Score</span>  </div></th>

                                <th style={{ width: 50 }}> </th>
                                <th style={{ width: 50 }}> </th>
                            </tr>
                        </thead>
                        <tbody>
                            {groupItems.map((item, index) => (
                                <ReportItem key={index} item={item} openReport={openReport} openCallReport={openCallReport} downloadPDF={downloadPDF}/>
                            ))}
                        </tbody>
                    </table>

                </div>)
        })

    );




}
